import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { BasePage, Helmet } from '@sm/webassets';
import { t } from '@sm/intl';

import MRXNav from './MRXNav';
import { NAV_VARIANT } from '../enums';

const COPY = {
  pageTitle: {
    id: 'mrx.MRXPage.pageTitle',
    defaultMessage: 'Market Research Solutions | SurveyMonkey',
    description:
      '[Type: Label][Vis: med] - Page title for all Market Research Experience pages'
  },
  pageDescription: {
    id: 'mrx.MRXPage.pageDescription',
    defaultMessage:
      'Collect quality data from your target market with Expert Solutions, ' +
      'global online panels, and market research services to help you get the insights you need, fast.',
    description:
      '[Type: Label][Vis: med] - Page meta description for all Market Research Experience pages'
  }
};

const MRXPage = ({ pageTitle, children }) => {
  const [mobileNavOpen, _setMobileNavOpen] = useState(false);
  const scrollPosition = useRef(0);
  const setMobileNavOpen = () => {
    if (!mobileNavOpen) scrollPosition.current = window.pageYOffset;
    _setMobileNavOpen(!mobileNavOpen);
  };
  useEffect(() => {
    if (!mobileNavOpen) window.scrollTo(0, scrollPosition.current);
  }, [mobileNavOpen]);
  return (
    <BasePage
      color="white"
      includeHeader
      includeFooter={!mobileNavOpen}
      pageId={`Market Research - ${pageTitle}`}
      legacyWeb=""
      sticky={false}
    >
      <Helmet>
        <title>{t(COPY.pageTitle)}</title>
        <meta name="description" content={t(COPY.pageDescription)} />
      </Helmet>
      <MRXNav
        variant={NAV_VARIANT.LIGHT}
        mobileOpen={mobileNavOpen}
        setMobileOpen={setMobileNavOpen}
      />
      <div className={classnames({ 'sm-mrx-nav--no-scroll': mobileNavOpen })}>
        {children}
      </div>
    </BasePage>
  );
};

MRXPage.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  children: PropTypes.node
};

MRXPage.defaultProps = {
  children: null
};

export default MRXPage;
